export default {
  apiKey: "AIzaSyAE-grHdbrZd5XQnqX8gGhm5Jh2F5S9ukQ",
  authDomain: "n2p-ai-dev.firebaseapp.com",
  projectId: "n2p-ai-dev",
  storageBucket: "n2p-ai-dev.appspot.com",
  messagingSenderId: "66658151423",
  appId: "1:66658151423:web:040eb0c43cbb6f6122d5ca",
};
